export const interopera_create = ['interopera.create']

export default [].concat(    
    interopera_create
)
